import { forwardRef } from 'react';

type ColumnGroupHeaderProps = {
  pinnedWidth: number;
  requiredWidth: number;
  optionalWidth: number;
};

export const ColumnGroupHeader = forwardRef<
  HTMLDivElement,
  ColumnGroupHeaderProps
>(({ pinnedWidth, requiredWidth, optionalWidth }, ref) => (
  <div className="flex border border-b-0 border-neutral-200 rounded-t-lg overflow-hidden">
    {/* Pinned section - stays fixed */}
    <div
      className="bg-base-primary text-white px-4 py-2 font-medium text-sm shrink-0"
      style={{ width: pinnedWidth }}
    >
      Required
    </div>
    <div ref={ref} className="flex overflow-x-auto scrollbar-hide">
      <div
        className="bg-base-primary text-white px-4 py-2 font-medium text-sm shrink-0"
        style={{ width: requiredWidth }}
      />
      <div
        className="bg-neutral-300 text-primary px-4 py-2 font-medium text-sm shrink-0"
        style={{ width: optionalWidth }}
      >
        Optional
      </div>
    </div>
  </div>
));

ColumnGroupHeader.displayName = 'ColumnGroupHeader';
